import React, { Component } from "react";
import { Link } from "react-router-dom";

class DeleteAccountSection extends Component {
  render() {
    return (
      <div className="main-content">
        <div className="ccpa-wrapper">
          <div className="component-section">
            <div className="section-top form-section">
              <h1 className="text-bold heading">ACCOUNT MANAGEMENT PORTAL</h1>
              <p>
                Welcome to the 7-Eleven and Speedway Account Management Portal. You can use the form below to submit requests to delete your rewards account.
              </p>
              <p>
                <br />
              </p>
              <p>
                We prioritize the protection of your privacy and will need to verify your identity before fulfilling your request. By utilizing this portal, you consent to receive a response via the email address or cell phone number you provide. We'll verify your identity through established authentication practices such as OTP verification via SMS and email.  The information you submit through this form serves the purpose of processing your request and maintaining a record of both your inquiry and our response.  
              </p>
              <p>
                <br />
              </p>
             <p>
              Please note:  If you elect to delete your loyalty account, all personal information associated with the account will also be deleted.  This includes, but is not limited to, your transaction history and other linked information.  Additionally, you will lose certain benefits including any existing point balance and other rewards you have earned.
             </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DeleteAccountSection;
